module.exports = __webpack_public_path__ + "static/media/default_ppt_image.dcb54352.svg";